import { useAppSelector } from 'app/hooks';
import AlertModal from 'components/common/AlertModal';
import ConfirmModal from 'components/common/ConfirmModal';
import FeatureTitleBar from 'components/common/FeatureTitleBar';
import useGlobalModal from 'components/common/GlobalModal/useGlobalModal';
import StatusHeader from 'components/common/StatusHeader';
import { selectIsEditMode } from 'features/common/editModeSlice';
import { useEffect, useState } from 'react';
import { Card, Col, Form, Row, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import AddDailyMenuButton from '../components/AddDailyMenuButton';
import AddHolidayDailyMenuButton from '../components/AddHolidayDailyMenuButton';
import { Day, DayJPMap } from '../constans';
import { DailyMenuSettings } from '../models';
import service from '../services';
import './style.scss';
function DailyMenu() {
  const { t } = useTranslation();
  const { showGlobalModal } = useGlobalModal();
  const history = useHistory();
  const [holiday, setHoliday] = useState<DailyMenuSettings['holiday_settings']>([]);
  const [weekday, setWeekday] = useState<DailyMenuSettings['weekday_settings']>([]);

  // selectors
  const isEditMode = useAppSelector(selectIsEditMode);

  useEffect(() => {
    service.get().then((response) => {
      setHoliday(response.data.holiday_settings);
      setWeekday(response.data.weekday_settings);
    });
  }, []);

  const handleSaveSettings = () => {
    const body = {
      holiday_settings: holiday,
      weekday_settings: weekday,
    };
    service.update(body).then(() => {
      showGlobalModal &&
        showGlobalModal(() => (
          <AlertModal
            title={t('DailyMenu.Validator.success')}
            message={t('DailyMenu.Validator.add_success')}
          ></AlertModal>
        ));
    });
  };

  return (
    <div className="page-wrapper daily-menu">
      <div className="page-header">
        <StatusHeader onAction={() => history.push('/')} />
      </div>
      <div className={`page-main ${isEditMode ? 'reedit-mode-wrapper' : ''}`}>
        <div className="page-content">
          <Card className={`col-md-6 col-lg-6 ${isEditMode ? 'reedit-mode-wrapper' : ''}`} style={{ padding: '10px' }}>
            <div>
              <FeatureTitleBar title={t('DailyMenu.Title')}></FeatureTitleBar>
            </div>
            <Row className="mb-2">
              <Col sm={12} lg={12} className="d-flex justify-content-end">
                <button type="button" className="btn btn-success" onClick={handleSaveSettings}>
                  {t('DailyMenu.Button.save')}
                </button>
              </Col>
            </Row>
            <Row>
              <Col>
                {t('DailyMenu.HolidayDesignation')} <br />
                {t('DailyMenu.HolidayContent')}
              </Col>
            </Row>
            <Card className="card border-0">
              <Table bordered>
                <thead className="text-center" style={{ backgroundColor: '#36489a', color: '#fff' }}>
                  <tr>
                    <th rowSpan={2} className="align-top" style={{ width: '40%' }}>
                      {t('DailyMenu.Table.holiday')}
                    </th>
                    <th rowSpan={1} className="align-top" style={{ width: '30%' }}>
                      {t('DailyMenu.Table.enable_disable')}
                    </th>
                    <th rowSpan={1} className="align-top" style={{ width: '15%' }}>
                      {t('DailyMenu.Table.target_menu')}
                    </th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {holiday.map((item, index) => (
                    <tr key={index}>
                      <td>{t('DailyMenu.Table.holiday_text')}</td>
                      <td>
                        <Form.Check
                          type="switch"
                          style={{ color: '#38D145', fontSize: '20px' }}
                          id={`custom-switch-${index}`}
                          checked={item.enabled}
                          onChange={(e) => {
                            const updatedHoliday = [...holiday];
                            updatedHoliday[index].enabled = e.target.checked;
                            setHoliday(updatedHoliday);
                            if (e.target.checked) {
                              showGlobalModal(() => (
                                <ConfirmModal
                                  title={t('App.confirm')}
                                  message={t('DailyMenu.Confirm.Enable_Holiday')}
                                  onCancel={() => {
                                    const updatedWeekday = [...weekday];
                                    updatedWeekday.forEach((item) => {
                                      if (item.day_of_week === Day.SATURDAY || item.day_of_week === Day.SUNDAY)
                                        item.enabled = false;
                                    });
                                    setWeekday(updatedWeekday);
                                    const updatedHoliday = [...holiday];
                                    updatedHoliday[index].enabled = false;
                                    setHoliday(updatedHoliday);
                                  }}
                                  onConfirm={() => {
                                    const updatedWeekday = [...weekday];
                                    updatedWeekday.forEach((item) => {
                                      if (item.day_of_week === Day.SATURDAY || item.day_of_week === Day.SUNDAY)
                                        item.enabled = false;
                                    });
                                    setWeekday(updatedWeekday);
                                  }}
                                />
                              ));
                            }
                          }}
                        />
                      </td>
                      <td>
                        <AddHolidayDailyMenuButton holidayId={item.id} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card>

            <Row>
              <Col>
                {t('DailyMenu.DayDesignation')} <br />
              </Col>
            </Row>

            <Card className="card border-0">
              <Table bordered>
                <thead className="text-center" style={{ backgroundColor: '#36489a', color: '#fff' }}>
                  <tr>
                    <th rowSpan={2} className="align-top" style={{ width: '40%' }}>
                      {t('DailyMenu.Table.weekdays')}
                    </th>
                    <th rowSpan={1} className="align-top" style={{ width: '30%' }}>
                      {t('DailyMenu.Table.enable_disable')}
                    </th>
                    <th rowSpan={1} className="align-top" style={{ width: '15%' }}>
                      {t('DailyMenu.Table.target_menu')}
                    </th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {weekday.map((item, index) => (
                    <tr key={index}>
                      <td>{service.convertWeekday(item.day_of_week)}</td>
                      <td>
                        <Form.Check
                          type="switch"
                          style={{ color: '#38D145', fontSize: '20px' }}
                          id={`custom-switch-${index}`}
                          checked={item.enabled}
                          onChange={(e) => {
                            if (
                              e.target.checked &&
                              (index === Day.SATURDAY || index === Day.SUNDAY) &&
                              holiday.some((item) => item.enabled)
                            ) {
                              showGlobalModal &&
                                showGlobalModal(() => (
                                  <AlertModal
                                    title={t('DailyMenu.Validator.error')}
                                    message={t('DailyMenu.Confirm.Enable_Sat_Sun_Day')}
                                  ></AlertModal>
                                ));
                            } else {
                              const updatedWeekday = [...weekday];
                              updatedWeekday[index].enabled = e.target.checked;
                              setWeekday(updatedWeekday);
                            }
                          }}
                        />
                      </td>
                      <td>
                        <AddDailyMenuButton dailyId={item.id} weeklyName={DayJPMap[item.day_of_week]} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default DailyMenu;
